import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiFileText, FiClipboard, FiCreditCard, FiAlertCircle, FiAward, FiCheckSquare } = FiIcons;

const TermsConditions = () => {
  const sections = [
    {
      icon: FiClipboard,
      title: "1. Ruang Lingkup Layanan",
      content: "Akademika Support menyediakan layanan dukungan teknis akademik meliputi editing naskah, layout, desain cover, dan parafrase. Kami tidak memberikan layanan penulisan substansi (ghostwriting) atau tindakan lain yang melanggar integritas akademik."
    },
    {
      icon: FiCheckSquare,
      title: "2. Proses Pemesanan",
      content: "Setiap pesanan dianggap sah setelah klien menyetujui penawaran harga dan jangka waktu pengerjaan. Klien wajib memberikan instruksi yang jelas dan data yang diperlukan untuk memulai proyek."
    },
    {
      icon: FiCreditCard,
      title: "3. Ketentuan Pembayaran",
      content: "Pembayaran dilakukan sesuai dengan termin yang disepakati (biasanya DP 50% di awal dan pelunasan setelah draf selesai). Pekerjaan akan diserahkan sepenuhnya setelah pelunasan diterima."
    },
    {
      icon: FiAward,
      title: "4. Hak Kekayaan Intelektual",
      content: "Seluruh hak cipta atas substansi naskah tetap berada pada klien. Akademika Support hanya memiliki hak atas elemen desain atau layout yang kami buat hingga pelunasan dilakukan, setelah itu hak pakai beralih sepenuhnya kepada klien."
    },
    {
      icon: FiAlertCircle,
      title: "5. Pembatalan & Revisi",
      content: "Pembatalan proyek oleh klien setelah pekerjaan dimulai akan dikenakan biaya proporsional. Revisi disediakan sesuai dengan jumlah yang disepakati dalam kontrak awal selama tidak mengubah substansi secara fundamental."
    }
  ];

  return (
    <div className="bg-white font-inter">
      {/* Header Section - Updated to a slightly deeper, elegant slate gradient for better definition */}
      <section className="bg-gradient-to-b from-slate-200/50 via-slate-100/20 to-white py-24 border-b border-divider relative overflow-hidden">
        {/* Subtle background decorative element */}
        <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/2 w-96 h-96 bg-primary/5 rounded-full blur-3xl pointer-events-none"></div>

        <div className="max-w-4xl mx-auto px-4 text-center relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary/10 mb-6 text-primary">
              <SafeIcon icon={FiFileText} className="w-8 h-8" />
            </div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-primary mb-6 tracking-tight">
              Syarat & Ketentuan
            </h1>
            <p className="text-lg text-secondary font-medium">
              Harap baca ketentuan penggunaan layanan kami dengan seksama.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-24">
        <div className="max-w-4xl mx-auto px-4">
          <div className="prose prose-lg max-w-none text-secondary mb-16">
            <p className="leading-relaxed mb-6">
              Dengan menggunakan layanan <strong>Akademika Support</strong>, Bapak/Ibu dianggap telah membaca, memahami, dan menyetujui seluruh syarat dan ketentuan yang berlaku di bawah ini. Ketentuan ini dibuat untuk melindungi hak-hak klien dan menjaga standar kualitas layanan kami.
            </p>
          </div>

          <div className="space-y-10">
            {sections.map((section, idx) => (
              <motion.div 
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: idx * 0.1 }}
                viewport={{ once: true }}
                className="p-8 rounded-2xl border border-divider hover:border-primary/20 transition-all"
              >
                <div className="flex items-start gap-6">
                  <div className="w-12 h-12 rounded-xl bg-primary/5 flex items-center justify-center text-primary shrink-0">
                    <SafeIcon icon={section.icon} className="w-6 h-6" />
                  </div>
                  <div>
                    <h2 className="text-xl font-bold text-primary mb-4">{section.title}</h2>
                    <p className="text-secondary leading-relaxed font-medium">
                      {section.content}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="mt-20 p-10 bg-gray-50 rounded-3xl border border-divider text-center"
          >
            <h3 className="text-xl font-bold text-primary mb-4">Butuh Penjelasan Lebih Lanjut?</h3>
            <p className="text-secondary mb-8 max-w-xl mx-auto font-medium">
              Jika ada poin dalam syarat dan ketentuan ini yang kurang jelas, tim legal kami siap memberikan penjelasan lebih detail.
            </p>
            <button className="bg-primary text-white px-8 py-3 rounded-xl font-bold hover:opacity-90 transition-all">
              Hubungi Tim Legal
            </button>
          </motion.div>

          <div className="mt-12 text-center text-sm font-bold text-secondary/40 uppercase tracking-[0.2em]">
            Terakhir diperbarui: 15 Januari 2024
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;